import styled from 'styled-components';

const StyledFullRealityScroll = styled.div`
  positon: relative;
  padding-top: ${props => parseInt(props.theme.components_spacing_desk.xxlarge) + 90}px;
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .intro--full,.outro--full{
    position: relative;
  }
  .intro--full h5, .outro--full h5{
    width: 66.66%;
    line-height: 130%;
  }
  .parallax--wrap{
    position: absolute;
    right: 0;
    width: 41.66%;
    top: 50%;
  }
  .parallax--wrap img{
    display: block;
    width: 100%;
  }
  h5 .green{
    color: ${props => props.theme.colors.green_secondary};
  }
  .center--full{
    padding: ${props => props.theme.components_spacing_desk.xlarge}px 0;
    pointer-events: none;
    position: relative;
  }
  .scroll-mask--full{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .change{
    position: relative;
    color: ${props => props.theme.colors.green_secondary};
    height: 170px;
    overflow: hidden;
  }
  .scroller--heading{
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .scroller--heading span{
    height: 170px;
    align-items: center;
    display: flex;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px;

  }
  @media screen and (max-width: 1023px){
   
    padding-top: ${props => parseInt(props.theme.components_spacing_tablet.xlarge) + 90}px;
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;

    .intro--full h5, .outro--full h5{
      width: 74.97%;
    }
  }
  @media screen and (max-width: 767px){
    
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${props => parseInt(props.theme.components_spacing_mobile.xlarge) + 90}px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .intro--full h5, .outro--full h5{
      width: 100%;
    }
    .parallax--wrap{
      display: none;
    }
  }
`;

export {
  StyledFullRealityScroll,
};

